import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminLessonListVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import type { LessonPaginationParams } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveLessons = createAsyncThunk<
  PaginatedResult<AdminLessonListVM>,
  LessonPaginationParams,
  { extra: Partial<Dependencies> }
>("lessons/adminRetrieveLessons", async ({ page = 1, pageSize = 50, sortBy, sortOrder, filters }, { extra: { adminRepository } }) => {
  return adminRepository!.listLessons({
    page,
    pageSize,
    sortBy,
    sortOrder,
    filters,
  });
});
